import { Injectable } from '@angular/core';
import { Key, KpdNavigator, NavigatorHelperBase } from '@kpd/framework-ngx';

@Injectable()
export class LicensesNavigatorHelper extends NavigatorHelperBase {
  constructor(navigator: KpdNavigator) {
    super(navigator);
  }
  composeOverviewUrl(): string {
    return `licenses`;
  }
  composeDetailUrl(key: Key<string>): string {
    return `licenses/details/license/${key.id}`;
  }
  composeCreateUrl(): string {
    return `licenses/details/license/0`;
  }
}
